import { useMemo } from "react";
import { themeData, topicsData } from "../data";

/**
 * 檢查字串是否包含搜尋字串
 * @param {string} str - 被檢查的字串
 * @param {string} search - 搜尋字串
 * @returns {boolean} 字串是否包含搜尋字串
 */

function containsString(str, search) {
	const lowerSearch = search.toLowerCase().trim();
	const regex = new RegExp(lowerSearch.replaceAll(" ", "|"), "i");
	return regex.test(str);
}

/**
 * @typedef {Object} FilteredData
 * @property {Object[]} filteredTopics - 符合搜尋與篩選條件的主題
 * @property {Object[]} filteredThemes - 符合篩選條件的主題
 */

/**
 * Filter the topics and themes based on the search query and selected theme filters.
 *
 * @param {string} search - The search query string.
 * @param {Set<string>} filter - The set of selected theme filters.
 * @returns {FilteredData} An object containing the filtered topics and themes.
 */
const useFilterChartDataTopics = (search, filter) => {
	const filteredTopics = useMemo(() => {
		return topicsData.filter((topic) => {
			return (
				filter.has(topic.theme) &&
				(containsString(topic.title, search) ||
					containsString(topic.description, search))
			);
		});
	}, [search, filter]);

	const filteredThemes = useMemo(() => {
		return themeData.filter((theme) => {
			return filter.has(theme.title);
		});
	}, [filter]);

	return { filteredTopics, filteredThemes };
};

export default useFilterChartDataTopics;
